import { render, staticRenderFns } from "./veStuMoralResourceShow.vue?vue&type=template&id=5d4ac58c&scoped=true"
import script from "./veStuMoralResourceShow.vue?vue&type=script&lang=js"
export * from "./veStuMoralResourceShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ac58c",
  null
  
)

export default component.exports